<template>
    <section class="justify-content-center mb-4">
        <div class="row">
            <div class="col-md-12 mx-auto dashboardstyle pt-0">
                <table style="width:100%;" class="mb-3">
                    <thead>
                        <tr>
                            <th  class="px-2">
                                <input
                                    type="text"
                                    style="font-size:11px; border:1px solid #3A9AF3; border-radius:5px; color:#3A9AF3; width:100%;"
                                    placeholder="Search by date"
                                    v-model="filtername"
                                    @change="onFilterdateChange()"
                                />
                            </th>
                            <th  class="px-2">
                                <input
                                    type="text"
                                    style="font-size:11px; border:1px solid #3A9AF3; border-radius:5px; color:#3A9AF3; width:100%;"
                                    placeholder="Search Country"
                                    v-model="filtercompany"
                                    @change="onFilterCountryChange()"
                                />
                            </th>
                        </tr>
                    </thead>
                </table>
                <table
                    class="abc-table mx-auto text-center"
                    style="width:100%;"
                >
                    <thead class="abc-title-table">
                        <tr style="border-bottom:solid 1px #3A9AF3;">
                            <th
                                class="py-3"
                                style="vertical-align: middle; width: 9%;"
                            >
                                {{ __("traductionview.publie") }}
                                <button
                                    style="text-align:center;"
                                    type="button"
                                    class="btn-sort"
                                    aria-label="Tri ascendant"
                                    v-on:click="dateSortAsc"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="9"
                                        height="9"
                                        fill="rgb(107, 107, 107)"
                                        class="bi bi-caret-up-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                                        />
                                    </svg>
                                </button>
                                <button
                                    style="text-align:center"
                                    type="button"
                                    class="btn-sort"
                                    aria-label="Tri descendant"
                                    v-on:click="dateSortDsc"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="9"
                                        height="9"
                                        fill="rgb(107, 107, 107)"
                                        class="bi bi-caret-down-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                                        />
                                    </svg>
                                </button>
                            </th>
                            <th style="vertical-align: middle; width: 8%;">
                                {{ __("traductionview.pays") }}
                                <button
                                    style="text-align:center;"
                                    type="button"
                                    class="btn-sort"
                                    aria-label="Tri ascendant"
                                    v-on:click="countrySortAsc"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="9"
                                        height="9"
                                        fill="rgb(107, 107, 107)"
                                        class="bi bi-caret-up-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                                        />
                                    </svg>
                                </button>
                                <button
                                    style="text-align:center"
                                    type="button"
                                    class="btn-sort"
                                    aria-label="Tri descendant"
                                    v-on:click="countrySortDsc"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="9"
                                        height="9"
                                        fill="rgb(107, 107, 107)"
                                        class="bi bi-caret-down-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                                        />
                                    </svg>
                                </button>
                            </th>
                            <th style="vertical-align: middle; width: 14%;">
                                {{ __("traductionview.status") }}
                            </th>
                            <th
                                style="vertical-align: middle; width: 14%;"
                            ></th>
                        </tr>
                    </thead>
                    <tbody
                        style="font-size: 11px; max-height: 600px; overflow: auto; display: block;"
                    >
                        <tr
                            v-for="(customer, index) in customs"
                            :key="index"
                            style="border-bottom:solid 1px rgb(206,206,206);"
                        >
                            <td
                                class="py-3"
                                style="vertical-align: middle; width: 9%;"
                            >
                                {{ customer.date }}
                            </td>
                            <td style="vertical-align: middle; width: 8%;">
                                {{ customer.country && customer.country.name }}
                            </td>
                            <td style="vertical-align: middle; width: 14%;">
                                {{ customer.status }}
                            </td>
                            <td style="vertical-align: middle; width: 14%;">
                                <div
                                    class="d-flex align-items-center justify-content-center"
                                    style="gap: 5px"
                                >
                                    <a
                                        :href="customer.route"
                                        class="btn btn-abc"
                                        target="_blank"
                                    >
                                        <span class="btn-abc">
                                            <i
                                                class="bi bi-eye"
                                                style="font-size: 1.1rem;"
                                            >
                                            </i>
                                        </span>
                                    </a>
                                    <form method="GET" :action="`/pdf`">
                                        <input
                                            name="url"
                                            type="hidden"
                                            :value="customer.route"
                                        />
                                        <button
                                            class="btn btn-outline-myfo"
                                            style="color: black;"
                                            type="submit"
                                        >
                                            <i
                                                class="bi bi-download"
                                                style="font-size: 1.1rem;"
                                            >
                                            </i>
                                        </button>
                                    </form>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    props: ["customers", "token", "route"],

    data() {
        return {
            customs: [],
            filtername: "",
            filtercompany: ""
        };
    },
    mounted() {
        if (
            this.customers &&
            this.customers[0] &&
            this.customers[0].estimates
        ) {
            this.customers[0].estimates.forEach(customer => {
                this.customs.push(customer);
            });
        }
    },
    methods: {
        onFilterdateChange() {
            this.customs = [];
            this.customers.forEach(customer => {
                var search = customer.date.toLowerCase();
                if (search.includes(this.filtername.toLowerCase())) {
                    this.customs.push(customer);
                }
            });
        },
        onFilterCountryChange() {
            this.customs = [];
            this.customers.forEach(customer => {
                var search = customer.country.name.toLowerCase();
                if (search.includes(this.filtercompany.toLowerCase())) {
                    this.customs.push(customer);
                }
            });
        },

        countrySortAsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.country.name < b.country.name) {
                    return -1;
                } else if (a.country.name > b.country.name) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },
        countrySortDsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.country.name > b.country.name) {
                    return -1;
                } else if (a.country.name < b.country.name) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },

        dateSortAsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.date < b.date) {
                    return -1;
                } else if (a.date > b.date) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },

        dateSortDsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.date > b.date) {
                    return -1;
                } else if (a.date < b.date) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }
    }
};
</script>
